import React, { useMemo, useState } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";

const TIMEZONE = "America/Winnipeg";

function toEvents(bookings) {
  return bookings.map((b) => ({
    id: b.id,
    title: b.title || "Unavailable",
    start: b.start_at,
    end: b.end_at,
    allDay: false,
  }));
}

function hasOverlap(range, events) {
  const start = new Date(range.start).getTime();
  const end = new Date(range.end).getTime();
  return events.some((evt) => {
    const evStart = new Date(evt.start).getTime();
    const evEnd = new Date(evt.end).getTime();
    return start < evEnd && end > evStart;
  });
}

export default function BookingCalendar({
  bookings = [],
  loading,
  onRangeChange,
  onSelectSlot,
  onRequestClick,
}) {
  const [currentRange, setCurrentRange] = useState(null);
  const events = useMemo(() => toEvents(bookings), [bookings]);

  return (
    <div className="booking-calendar card">
      <div className="booking-calendar__toolbar">
        <div>
          <p className="text-muted" style={{ margin: 0 }}>
            Availability shown in {TIMEZONE}.
          </p>
        </div>
        <button type="button" className="btn btn-primary" onClick={onRequestClick}>
          Request Booking
        </button>
      </div>
      <FullCalendar
        plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
        initialView="timeGridWeek"
        headerToolbar={{
          left: "prev,next today",
          center: "title",
          right: "dayGridMonth,timeGridWeek,timeGridDay",
        }}
        timeZone={TIMEZONE}
        selectable
        selectMirror
        select={(info) => onSelectSlot && onSelectSlot(info)}
        selectAllow={(info) => !hasOverlap(info, events)}
        datesSet={(info) => {
          const nextRange = { start: info.startStr, end: info.endStr };
          if (
            !currentRange ||
            currentRange.start !== nextRange.start ||
            currentRange.end !== nextRange.end
          ) {
            setCurrentRange(nextRange);
            if (onRangeChange) onRangeChange(nextRange);
          }
        }}
        events={events}
        eventColor="#c18a27"
        eventTextColor="#111"
        height="auto"
        allDaySlot={false}
        slotMinTime="06:00:00"
        slotMaxTime="24:00:00"
        nowIndicator
        dayMaxEvents
        displayEventTime
      />
      {loading ? <p className="text-muted" style={{ marginTop: 10 }}>Loading availability...</p> : null}
    </div>
  );
}
